export default "__VITE_ASSET__Do588_c5__"